import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.AddNewBudgetPopupContent', {
    title: 'Upload budget',
    addButton: 'Add budget',
    description: `
        ApprovalMax allows to upload budgets in a pre-defined .csv file format. {learnMore}{br}{br}
        The file format is defined by the Xero Budget Manager. Files downloaded from the Xero Budget Manager can be uploaded without any adjustments.
    `,
    learnMore: 'Learn more',
    nameLabel: 'Budget name',
    fileHeadline: 'Budget file',
    createdMessage: 'Budget created',
});
